/**
 * Mega Menu — Seedcube Theme (Tabbed Edition)
 * Vanilla JS only. No jQuery. No external libraries.
 *
 * Handles:
 *   - Desktop: multiple top-level triggers, each with its own panel
 *   - Desktop tab switching with JS-driven stagger animation
 *   - Escape / click-outside / touch-outside closes open panel
 *   - Mobile slide-in drawer with body scroll lock
 *   - Mobile: one top-level tab per group that has categories (1–3), shared panel area below
 *   - Mobile category tab switching (scoped to active group) + stagger animation
 *   - Focus trap inside open drawer
 *   - Dynamic panel top offset (CSS var --sc-header-offset)
 */

document.addEventListener('DOMContentLoaded', function () {

  var triggers = document.querySelectorAll('.sc-mega-menu__trigger[data-mega-trigger]');
  var panels = document.querySelectorAll('.sc-mega-menu__panel[data-mega-panel]');
  var burgerCheckbox = document.getElementById('sc-mega-menu-burger');
  var overlay = document.getElementById('scMegaOverlay');
  var drawer = document.getElementById('scMegaDrawer');
  var siteHeader = document.getElementById('SiteHeader');

  var HOVER_OPEN_DELAY = 80;
  var HOVER_CLOSE_DELAY = 150;
  var hoverTimer = null;
  var rafPending = false;

  function getPanelForGroup(group) {
    return document.querySelector('.sc-mega-menu__panel[data-mega-panel="' + group + '"]');
  }

  function isAnyPanelOpen() {
    return Array.prototype.some.call(panels, function (p) {
      return p.classList.contains('is-open');
    });
  }

  function updatePanelOffset() {
    if (!siteHeader) return;
    var rect = siteHeader.getBoundingClientRect();
    document.documentElement.style.setProperty('--sc-header-offset', rect.bottom + 'px');
  }

  function requestOffsetUpdate() {
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(function () {
        updatePanelOffset();
        rafPending = false;
      });
    }
  }

  window.addEventListener('scroll', requestOffsetUpdate, { passive: true });
  window.addEventListener('resize', requestOffsetUpdate, { passive: true });
  updatePanelOffset();

  function retriggerAnimation(container, isMobile) {
    var selector = isMobile ? '.sc-mega-menu__drawer-card' : '.sc-mega-menu__card';

    var cssStagger = getComputedStyle(document.documentElement)
      .getPropertyValue('--sc-anim-stagger');
    var stagger = parseFloat(cssStagger);
    if (!stagger || isNaN(stagger)) {
      stagger = isMobile ? 100 : 120;
    }

    var cards = container.querySelectorAll(selector);

    cards.forEach(function (card) {
      card.classList.remove('--animate');
      card.style.animationDelay = '';
    });

    void container.offsetHeight;

    cards.forEach(function (card, index) {
      card.style.animationDelay = (index * stagger) + 'ms';
      card.classList.add('--animate');
    });
  }

  function switchDesktopTab(tabId, panelEl) {
    if (!panelEl) return;

    panelEl.querySelectorAll('.sc-mega-menu__tab[data-tab]').forEach(function (btn) {
      var active = btn.getAttribute('data-tab') === tabId;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panelEl.querySelectorAll('.sc-mega-menu__card-set').forEach(function (set) {
      var active = set.getAttribute('data-tabpanel') === tabId;
      if (active) {
        set.classList.add('is-active');
        retriggerAnimation(set, false);
      } else {
        set.classList.remove('is-active');
      }
    });
  }

  function switchMobileTab(tabId) {
    if (!drawer) return;
    var mobilePanel = drawer.querySelector('.sc-mega-menu__mobile-panel.is-active');
    if (!mobilePanel) return;

    mobilePanel.querySelectorAll('.sc-mega-menu__tab[data-mob-tab]').forEach(function (btn) {
      var active = btn.getAttribute('data-mob-tab') === tabId;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    mobilePanel.querySelectorAll('.sc-mega-menu__drawer-cards').forEach(function (cards) {
      var active = cards.getAttribute('data-mobile-tabpanel') === tabId;
      if (active) {
        cards.classList.add('is-active');
        retriggerAnimation(cards, true);
      } else {
        cards.classList.remove('is-active');
      }
    });
  }

  function switchMobileGroup(group) {
    if (!drawer) return;
    drawer.querySelectorAll('.sc-mega-menu__mobile-trigger').forEach(function (btn) {
      var on = btn.getAttribute('data-mobile-group') === group;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    drawer.querySelectorAll('.sc-mega-menu__mobile-panel').forEach(function (pan) {
      var on = pan.getAttribute('data-mobile-panel') === group;
      pan.classList.toggle('is-active', on);
      pan.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    var pan = drawer.querySelector('.sc-mega-menu__mobile-panel[data-mobile-panel="' + group + '"]');
    if (pan) {
      var ac = pan.querySelector('.sc-mega-menu__drawer-cards.is-active');
      if (ac) retriggerAnimation(ac, true);
    }
  }

  panels.forEach(function (panelEl) {
    panelEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.sc-mega-menu__tab[data-tab]');
      if (btn && panelEl.contains(btn)) {
        switchDesktopTab(btn.getAttribute('data-tab'), panelEl);
      }
    });

    var tabHoverTimer = null;
    panelEl.querySelectorAll('.sc-mega-menu__tab[data-tab]').forEach(function (tab) {
      tab.addEventListener('mouseenter', function () {
        var tabId = tab.getAttribute('data-tab');
        clearTimeout(tabHoverTimer);
        tabHoverTimer = setTimeout(function () {
          switchDesktopTab(tabId, panelEl);
        }, 60);
      });
      tab.addEventListener('mouseleave', function () {
        clearTimeout(tabHoverTimer);
      });
    });
  });

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var topTrigger = e.target.closest('.sc-mega-menu__mobile-trigger');
      if (topTrigger) {
        var grp = topTrigger.getAttribute('data-mobile-group');
        if (grp) switchMobileGroup(grp);
        return;
      }
      var activeMobilePanel = drawer.querySelector('.sc-mega-menu__mobile-panel.is-active');
      if (!activeMobilePanel) return;
      var btn = e.target.closest('.sc-mega-menu__tab[data-mob-tab]');
      if (btn && activeMobilePanel.contains(btn)) {
        switchMobileTab(btn.getAttribute('data-mob-tab'));
      }
    });
  }

  function closeAllMegaPanels() {
    panels.forEach(function (p) {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });
    triggers.forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
  }

  function openPanelForGroup(group, triggerEl) {
    var panel = getPanelForGroup(group);
    if (!panel || !triggerEl) return;
    closeAllMegaPanels();
    updatePanelOffset();
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    triggerEl.setAttribute('aria-expanded', 'true');
    var activeSet = panel.querySelector('.sc-mega-menu__card-set.is-active');
    if (activeSet) retriggerAnimation(activeSet, false);
  }

  panels.forEach(function (panelEl) {
    panelEl.addEventListener('mouseenter', function () {
      clearTimeout(hoverTimer);
    });
    panelEl.addEventListener('mouseleave', function () {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(closeAllMegaPanels, HOVER_CLOSE_DELAY);
    });
  });

  triggers.forEach(function (trigger) {
    var group = trigger.getAttribute('data-mega-trigger');
    if (!group) return;

    trigger.addEventListener('mouseenter', function () {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () {
        openPanelForGroup(group, trigger);
      }, HOVER_OPEN_DELAY);
    });

    trigger.addEventListener('mouseleave', function () {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(closeAllMegaPanels, HOVER_CLOSE_DELAY);
    });

    trigger.addEventListener('click', function () {
      var panel = getPanelForGroup(group);
      if (!panel) return;
      if (panel.classList.contains('is-open') && trigger.getAttribute('aria-expanded') === 'true') {
        closeAllMegaPanels();
      } else {
        openPanelForGroup(group, trigger);
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) {
      return;
    }
    if (!isAnyPanelOpen()) return;
    var expandedTrigger = document.querySelector('.sc-mega-menu__trigger[data-mega-trigger][aria-expanded="true"]');
    closeAllMegaPanels();
    if (expandedTrigger) {
      expandedTrigger.focus();
    } else if (triggers[0]) {
      triggers[0].focus();
    }
  });

  document.addEventListener('click', function (e) {
    if (!isAnyPanelOpen()) return;
    if (e.target.closest('.sc-mega-menu__trigger') || e.target.closest('.sc-mega-menu__panel')) {
      return;
    }
    closeAllMegaPanels();
  });

  document.addEventListener('touchstart', function (e) {
    if (!isAnyPanelOpen()) return;
    if (e.target.closest('.sc-mega-menu__trigger') || e.target.closest('.sc-mega-menu__panel')) {
      return;
    }
    closeAllMegaPanels();
  }, { passive: true });

  var FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function lockScroll() {
    document.body.style.overflow = 'hidden';
    document.body.classList.add('sc-drawer-open');
  }

  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.classList.remove('sc-drawer-open');
  }

  function openDrawer() {
    if (!drawer || !overlay) return;
    var firstMobileTrigger = drawer.querySelector('.sc-mega-menu__mobile-trigger[data-mobile-group]');
    if (firstMobileTrigger) {
      var defaultGroup = firstMobileTrigger.getAttribute('data-mobile-group');
      if (defaultGroup) switchMobileGroup(defaultGroup);
    }
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    if (burgerCheckbox) burgerCheckbox.checked = true;
    lockScroll();
    var firstEl = drawer.querySelector(FOCUSABLE);
    if (firstEl) firstEl.focus();
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    if (burgerCheckbox) burgerCheckbox.checked = false;
    unlockScroll();
  }

  if (burgerCheckbox) {
    burgerCheckbox.addEventListener('change', function () {
      if (this.checked) {
        openDrawer();
      } else {
        closeDrawer();
      }
    });
  }

  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  /* Keep the burger checkbox in step with the drawer.
     Browsers restore a checkbox's checked state on Back/Forward and reload
     without firing 'change', which left the X showing with no drawer open. */
  function syncBurger() {
    if (burgerCheckbox && drawer) {
      burgerCheckbox.checked = drawer.classList.contains('is-open');
    }
  }
  syncBurger();
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
    syncBurger();
  });

  /* Rotating or resizing to desktop width with the drawer open would otherwise leave the page scroll-locked. */
  var mqDesktopMenu = window.matchMedia('(min-width: 990px)');
  function onMenuBreakpoint(e) {
    if (e.matches && drawer && drawer.classList.contains('is-open')) closeDrawer();
  }
  if (mqDesktopMenu.addEventListener) mqDesktopMenu.addEventListener('change', onMenuBreakpoint);
  else if (mqDesktopMenu.addListener) mqDesktopMenu.addListener(onMenuBreakpoint);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  if (drawer) {
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (!drawer.classList.contains('is-open')) return;

      var focusable = Array.prototype.slice.call(
        drawer.querySelectorAll(FOCUSABLE)
      ).filter(function (el) {
        return !el.disabled && el.offsetParent !== null;
      });

      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

});
